import { HttpClient, HttpResponse } from '@angular/common/http';
import { AfterViewChecked, AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ChatService } from '../utilities/services/chat.service';
import { HttpService } from '../utilities/services/http.service';
import { v4 as uuid } from 'uuid';
// import { saveAs as importedSaveAs } from 'file-saver';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { FillinResponseDialogComponent } from '../register-callout/fillin-response-dialog/fillin-response-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe } from '@angular/common';
import { canCreateThread } from '../utilities/enums/cancreatethread.enum';
import { AppComponent } from '../app.component';

import { ConnectionsComponent } from '../connections/connections.component'

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
})


export class ChatComponent
  implements OnInit, AfterViewInit, AfterViewChecked, OnDestroy {
  @ViewChild('chathistory', { static: false }) content!: ElementRef;
  @ViewChild('message', { static: true }) inputSearch!: ElementRef;
  private maxTextareaRows = 3;

  // connectionList: any[] = []
  chatList: any[] = [];
  loadAll: boolean = false;
  message!: string;
  inChatScreen = false;
  subscriptions: any = [];
  chatGroups: string[] = [];

  isUploadingMedia: boolean = false;
  isDownloadingMedia: boolean = false;
  private timeoutIds: any[] = [];

  @Input() toChatUserId?: any;
  @Input() toChatUserName?: any;
  @Input() fromNewMessage: boolean | undefined;
  @Input() groupName?: string | undefined;
  @Input() connectionId?: string | undefined;
  @Input() alertGroup?: boolean | undefined;

  @Input() forwardMsg: any;

  @Output() forwardMessage = new EventEmitter();
  @Output() gotoConversations = new EventEmitter();

  selection = new SelectionModel<any>(true, []);
  userRole: any
  canCreateThread: Boolean = false
  isuserRealm: boolean = false
  constructor(
    private chatService: ChatService,
    private httpService: HttpService,
    private httpClient: HttpClient,
    private router: Router,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    public translate: TranslateService,
    public appComponent: AppComponent
  ) {
    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('en');
    const browserLang = translate.getBrowserLang() || 'en';
    translate.use(browserLang.match(/en|fr/) ? browserLang : 'en');
    const userRealm = localStorage.getItem('userRealm');
    this.isuserRealm = (userRealm && userRealm.trim() !== '') ? true : false
    this.userRole = localStorage.getItem('Role');

    if (this.userRole && canCreateThread['CREATE'].includes(this.userRole)) {
      this.canCreateThread = true
      // console.log('User has permission to CREATE the thread.');
    }
  }

  close() {
    this.gotoConversations.emit(true);
  }

  getToUserName() {
    return this.toChatUserName;
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.inChatScreen = true;

    // get the chat history we previously chat
    this.getChatHistory();

    // all incoming message we will get here
    const msgSub = this.chatService.getMessages().subscribe((message: any) => {
      if (
        message.fromUserId === this.toChatUserId ||
        message.toUserId === this.toChatUserId
      ) {
        let chatNew = true;
        this.chatList.map(chatItem => {
          if (chatItem.messageId === message.messageId)
            chatNew = false;
        })
        if (chatNew) {
          message.createTime = new Date();
          this.chatList.push(message);
        }

        this.timeoutIds.push(setTimeout(() => {
          // In chat screen send read receipt
          if (this.inChatScreen) {
            const readData = {
              fromUserId: message.fromUserId,
              toUserId: message.toUserId,
              messageId: message.messageId,
            };

            this.chatService.sendMessageRead(readData);
          }
          this.scrollToBottom();
        }, 100));
      }
    });
    this.subscriptions.push(msgSub);

    // all messages we will get here whose send by sender themselves
    const sendMsgSub = this.chatService.getsenderMessages().subscribe((message: any) => {
      if (message.fromUserId === this.loginUser() || message.toUserId === this.loginUser() 
        || this.chatGroups.includes(message.fromUserId) || this.chatGroups.includes(message.toUserId) ) {
        let chatNew = true;
        this.chatList.map(chatItem => {
          if (chatItem.messageId === message.messageId)
            chatNew = false;
        })
        if (chatNew) {
          message.createTime = new Date();
          this.chatList.push(message);
        }

        this.timeoutIds.push(setTimeout(() => {
          this.scrollToBottom();
        }, 50));
      }
    });
    this.subscriptions.push(sendMsgSub);

    // we will get message received receipt
    const rrSub = this.chatService.getReceiptReceivedByServer().subscribe((message: any) => {
      // UPDATE message status here to received
      const index = this.chatList.findIndex(
        (chat) => chat.messageId === message.messageId
      );
      if (index > -1) {
        this.chatList[index].messageStatus = 'RECEIVED';
      }
    });
    this.subscriptions.push(rrSub);

    // we will get message delivery receipt
    const drSub = this.chatService.getMessageDeliveredReceipt().subscribe((message: any) => {
      // UPDATE message status here to DELIVERED
      const index = this.chatList.findIndex(
        (chat) => chat.messageId === message.messageId
      );
      if (index > -1) {
        this.chatList[index].messageStatus = 'DELIVERED';
      }
    });
    this.subscriptions.push(drSub);

    // we will get message read receipt, that means your message read by the receiver
    const mrrSub = this.chatService.getMessageReadReceipt().subscribe((message: any) => {
      // UPDATE message status here to READ
      const index = this.chatList.findIndex(
        (chat) => chat.messageId === message.messageId
      );
      if (index > -1) {
        this.chatList[index].messageStatus = 'READ';
      }
    });
    this.subscriptions.push(mrrSub);

    // broadcast accept
    const brdac = this.chatService.getBroadCastAccept().subscribe((message: any) => {
      // UPDATE message status here to READ
      const index = this.chatList.findIndex(
        (chat) => chat.messageId === message.messageId
      );
      if (index > -1) {
        this.chatList[index].isAvailable = message.isAvailable;
      }
    });

    this.subscriptions.push(brdac);

    // all history messages we will get here
    const chSub = this.chatService.getChatHistoryData().subscribe((message: any) => {
      let userRole = localStorage.getItem('Role');
      if (message.length > 0) {
        for (let index = 0; index < message.length; index++) {
          const element = message[index];
          if ((element.fromUserId === this.loginUser() && element.toUserId === this.toChatUserId) ||
            (element.fromUserId === this.toChatUserId && element.toUserId === this.loginUser()))
            this.chatList.unshift(element);
          if (userRole === "SPECIALTYSUPPORT" || userRole === "ADMIN" || userRole === "SUPPORT" || userRole === "SEMBRANETADMIN" || userRole === "SEMBRANETOFFICE") {
            if (this.chatGroups.length > 0) {
              if ((this.chatGroups.includes(element.fromUserId) && element.toUserId === this.toChatUserId) ||
                (element.fromUserId === this.toChatUserId && this.chatGroups.includes(element.toUserId)))
                this.chatList.unshift(element);
            }
          }
        }

        if (this.toChatUserName == null || this.toChatUserName == '') {
          if (this.chatList.length > 0) {
            const name =
              this.chatList[this.chatList.length - 1]?.fromUserName;
            if (name) {
              this.toChatUserName = name.toString();
            }
          }
        }

        this.timeoutIds.push(setTimeout(() => {
          this.scrollToBottom();
        }, 100));
        // sending READ receipt the reason behind it we read message in screen
        this.sendReadReceipt();
      }
    })

    this.subscriptions.push(chSub);

    if (this.forwardMsg) {
      this.message = this.forwardMsg;
    }

    const rawGroups = localStorage.getItem('chatGroups') || '';
    this.chatGroups = rawGroups ? rawGroups.split(',').map(g => g.trim()).filter(Boolean) : [];
  }

  bringToInternalPage(message: string) {
    try {

      message = message.replaceAll("http://", "https://")

      let isMobile = window.innerWidth <= 810;

      if (isMobile) {
        this.close();
        ConnectionsComponent.self.close();
      }

      const urlRegex = /(https?:\/\/[^\s<>'")]+)([)\].,;!?]*)/gi;

      const u = new URL(message.match(urlRegex)![0]);

      let currentHost = window.location.hostname;

      if (currentHost && u.hostname === currentHost) {
        this.router.navigateByUrl(`/`, {}).then(() => { // navigate to root first to avoid same url navigation
          this.router.navigateByUrl(`/${u.pathname}`, {});
        });
      }

    } catch { }
  }


  // send message function
  sendMessage() {
    let userRole = localStorage.getItem("Role")
    if (this.message) {
      const messageData = {
        fromUserId: this.loginUser(),
        fromUserName: localStorage.getItem('userName'),
        toUserId: this.toUserId(),
        toUserName: this.toChatUserName,
        message: this.message,
        timeStamp: new Date(),
        messageType: 'TEXT',
        messageId: uuid(),
        media: '',
        mediaThumb: '',
        messageStatus: 'PENDING',
        createTime: new Date().toUTCString(),
      };

      if (userRole === "SPECIALTYSUPPORT" || userRole === "ADMIN" || userRole === "SUPPORT" || userRole === "SEMBRANETADMIN" || userRole === "SEMBRANETOFFICE") {
        if (this.chatList[0]) {
          if (this.chatGroups.length > 0) {
            if (this.chatGroups.includes(this.toChatUserId)) {
              messageData.fromUserId = this.toChatUserId;
              messageData.fromUserName = this.toChatUserName;
              let interGroupMessage = localStorage.getItem('userName') + ": " + messageData.message;
              messageData.message = interGroupMessage;
            } else if (this.chatGroups.includes(this.chatList[0].fromUserId)) {
              messageData.fromUserId = this.chatList[0].fromUserId;
              messageData.fromUserName = this.chatList[0].fromUserName;
              let supportMessage = localStorage.getItem('userName') + " (" + this.chatList[0].fromUserName + "): " + messageData.message;
              messageData.message = supportMessage;
            } else if (this.chatGroups.includes(this.chatList[0].toUserId)) {
              messageData.fromUserId = this.chatList[0].toUserId;
              messageData.fromUserName = this.chatList[0].toUserName;
              let supportMessage = localStorage.getItem('userName') + " (" + this.chatList[0].toUserName + "): " + messageData.message;
              messageData.message = supportMessage;
            }
          }
        } else {
          if (this.chatGroups.length > 0) {
            if (this.chatGroups.includes(this.toChatUserId)) {
              messageData.fromUserId = this.toChatUserId;
              messageData.fromUserName = this.toChatUserName;
              let interGroupMessage = localStorage.getItem('userName') + ": " + messageData.message;
              messageData.message = interGroupMessage;
            }
          }
        }
      }
      this.chatService.sendMessage(messageData);
      this.chatList.push(messageData);

      this.message = '';
      this.resetTextareaSize();
      this.timeoutIds.push(setTimeout(() => {
        this.scrollToBottom();
      }, 25));
    }
  }

  sendReceivedReceipt() {
    const data = this.chatList.filter(
      (item) =>
        item.fromUserId === this.toUserId() && item.messageStatus === 'RECEIVED'
    );
    if (data) {
      data.forEach((message, index) => {
        const readData = {
          fromUserId: message.fromUserId,
          toUserId: message.toUserId,
          messageId: message.messageId,
        };
        this.chatService.sendMessageReceived(readData);
      });
    }
  }

  sendReadReceipt() {
    const data = this.chatList.filter(
      (item) =>
        item.fromUserId === this.toUserId() &&
        (item.messageStatus === 'RECEIVED' ||
          item.messageStatus === 'DELIVERED')
    );
    if (data) {
      data.forEach((message, index) => {
        const readData = {
          fromUserId: message.fromUserId,
          toUserId: message.toUserId,
          messageId: message.messageId,
        };
        this.chatService.sendMessageRead(readData);
      });
    }
  }

  getChatHistory(loadMore?) {
    if (loadMore)
      this.loadAll = true;
    let timeStampDate = new Date().toISOString();
    if (this.chatList.length > 0)
      timeStampDate = this.chatList[0].createTime;
    if (this.groupName) {
      const data = {
        fromUserId: this.groupName,
        toUserId: this.toUserId(),
        timeStamp: timeStampDate,
        limit: 20,
      };
      if (data.fromUserId && data.toUserId)
        this.chatService.requestChatHistory(data);
    } else {
      const data = {
        fromUserId: this.loginUser(),
        toUserId: this.toUserId(),
        timeStamp: timeStampDate,
        limit: 20,
      };
      if (data.fromUserId && data.toUserId)
        this.chatService.requestChatHistory(data);
    }
  }

  sendBroadcastYesNo(msgdata: any, isAvailable: boolean, status: string) {
    this.openDialog(msgdata, isAvailable, status);
  }

  setToUserId(id: string) {
    localStorage.setItem('toUserId', id);
  }

  toUserId() {
    return this.toChatUserId;
  }

  loginUser(): string | null {
    return localStorage.getItem('userId');
  }

  isSender(chat: any): boolean {
    const currentUserName = localStorage.getItem('userName') || '';

    if (chat.message) {
      const senderName = this.extractSenderName(chat.message);
      if (senderName && currentUserName) {
        return senderName.startsWith(currentUserName);
      }
    }

    if (chat.fromUserName && currentUserName) {
      return chat.fromUserName === currentUserName;
    }

    if (this.loginUser() === chat.fromUserId)
      return true;

    return false;
  }

  getDisplayMessage(chat: any): string {
    if (!chat.message) return '';
    const senderName = this.extractSenderName(chat.message);
    if (senderName) return chat.message;
    const name = chat.fromUserName || '';
    return name ? name + ': ' + chat.message : chat.message;
  }

  extractSenderName(message: string): string | null {
    if (!message) return null;
    const colonIndex = message.indexOf(': ');
    return colonIndex > 0 ? message.substring(0, colonIndex) : null;
  }

  isOutsideParty(chat: any): boolean {
    if (this.chatGroups.length === 0 || !chat.message) return false;
    const senderName = this.extractSenderName(chat.message);
    if (!senderName) return true;
    if (this.toChatUserName && senderName.startsWith(this.toChatUserName)) return true;
    return false;
  }

  hasOutsideParty(): boolean {
    if (this.chatGroups.length === 0) return false;
    return this.chatList.some(chat => this.isOutsideParty(chat));
  }

  public messageStatusIcon(chat: any) {
    if (chat.messageStatus === 'PENDING') {
      return 'fa fa-clock-o';
    } else if (chat.messageStatus === 'RECEIVED') {
      return 'fa fa-check';
    } else if (chat.messageStatus === 'DELIVERED') {
      return 'fa fa-check';
    } else if (chat.messageStatus === 'READ') {
      return 'fa fa-check';
    } else {
      return '';
    }
  }

  public colorIcon(chat: any) {
    if (chat.messageStatus === 'PENDING') {
      return { color: 'gray' };
    } else if (chat.messageStatus === 'RECEIVED') {
      return { color: 'lightgray' };
    } else if (chat.messageStatus === 'DELIVERED') {
      return { color: 'lightgray' };
    } else if (chat.messageStatus === 'READ') {
      return { color: 'green' };
    } else {
      return { color: '' };
    }
  }

  ngAfterViewChecked() { }

  logScrollStart(event: any) {
  }

  logScrolling(event: any) {
  }

  logScrollEnd(event: any) {
  }

  scrollToBottom(): void {
    this.timeoutIds.push(setTimeout(() => {
      this.content.nativeElement.scroll({
        top: this.content.nativeElement.scrollHeight,
        left: 0,
        behavior: 'smooth',
      });
    }, 500));
  }

  scrollToTop() {
    // this.content.scrollToTop(0);
  }

  scrollToPoint(x: number, y: number) {
    // this.content.scrollToPoint(x, y, 0);
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  openDialog(msgdata: any, isAvailable: boolean, status: string) {
    const dialogRef = this.dialog.open(FillinResponseDialogComponent, {
      data: { msgdata, status },
    });

    dialogRef.afterClosed().subscribe((result) => {
      // move to the fill-in alert screen
      if (result) {
        msgdata.isAvailable = isAvailable;
        let data = {
          fromUserId: this.loginUser(),
          toUserId: this.toUserId(),
          messageId: msgdata.messageId,
          isAvailable: isAvailable,
          status: status
        };
        if (data.fromUserId && data.toUserId) {
          this.chatService.broadcastYesNo(data);
        }
        this.acceptRejectBroadCast(msgdata, status, result.notes);
      }
    });
  }

  acceptRejectBroadCast(data: any, status: string, notes: string) {
    const body = {
      userShiftId: data.userShiftId,
      shiftStatus: status,
      notes: notes,
    };

    this.httpService.acceptRejectShift(body).subscribe({
      next: (res: any) => {
        if (status === 'ACCEPT') {
          this.openSnackBar('You accepted', '');
        } else {
          this.openSnackBar('You rejected', '');
        }
      },
      error: (error) => {
        if (error.status === 401) {
          this.appComponent.renewToken()
          // localStorage.clear();
          // this.router.navigate(['/login']);
        }
      },
      complete: () => { },
    });
  }

  onPaste(event: ClipboardEvent) {
    const items = event.clipboardData?.items;
    if (!items) return;
    for (let i = 0; i < items.length; i++) {
      if (items[i].type.startsWith('image/')) {
        event.preventDefault();
        const file = items[i].getAsFile();
        if (file) {
          this.onUpload(file, 'MEDIA');
        }
        return;
      }
    }
  }

  onFileChanged(event: any, fileType: any) {
    const selectedFile = event.target.files[0];
    this.onUpload(selectedFile, fileType);
  }

  onUpload(selectedFile: File, fileType: any) {
    this.isUploadingMedia = true;
    const profileData = new FormData();
    profileData.append('files', selectedFile);
    this.httpClient
      .post(environment.AUTH_API_URL + 'fileupload', profileData, {
        headers: this.httpService.getFormDataHeaders(),
      })
      .subscribe({
        next: (res: any) => {
          this.isUploadingMedia = false;
          this.sendFile(res.file[0].key, res.file[0].key, fileType);
        },
        error: (error: any) => {
          console.error('error', error);
          this.isUploadingMedia = false;
          let errorMessage = error.error ? error.error.message : "Error Uploading File";
          this.openSnackBar(errorMessage, "")
        },
        complete: () => { },
      });
  }

  sendFile(media: any, thumb: any, fileType: any) {
    if (media && thumb) {
      const messageData = {
        fromUserId: this.loginUser(),
        fromUserName: localStorage.getItem('userName'),
        toUserName: this.toChatUserName,
        toUserId: this.toUserId(),
        message: this.message,
        timeStamp: new Date(),
        messageType: 'MEDIA',
        messageId: uuid(),
        media,
        mediaThumb: thumb,
        messageStatus: 'PENDING',
      };

      let userRole = localStorage.getItem("Role")
      if (userRole === "SPECIALTYSUPPORT" || userRole === "ADMIN" || userRole === "SUPPORT" || userRole === "SEMBRANETADMIN" || userRole === "SEMBRANETOFFICE") {
        if (this.chatList[0]) {
          if (this.chatGroups.length > 0) {
            if (this.chatGroups.includes(this.toChatUserId)) {
              messageData.fromUserId = this.toChatUserId;
              messageData.fromUserName = this.toChatUserName;
              let interGroupMessage = localStorage.getItem('userName') + ": " + messageData.mediaThumb;
              messageData.mediaThumb = interGroupMessage;
            } else if (this.chatGroups.includes(this.chatList[0].fromUserId)) {
              messageData.fromUserId = this.chatList[0].fromUserId;
              messageData.fromUserName = this.chatList[0].fromUserName;
              let supportMessage = localStorage.getItem('userName') + " (" + this.chatList[0].fromUserName + "): " + messageData.mediaThumb;
              messageData.mediaThumb = supportMessage;
            } else if (this.chatGroups.includes(this.chatList[0].toUserId)) {
              messageData.fromUserId = this.chatList[0].toUserId;
              messageData.fromUserName = this.chatList[0].toUserName;
              let supportMessage = localStorage.getItem('userName') + " (" + this.chatList[0].toUserName + "): " + messageData.mediaThumb;
              messageData.mediaThumb = supportMessage;
            }
          }
        } else {
          if (this.chatGroups.length > 0) {
            if (this.chatGroups.includes(this.toChatUserId)) {
              messageData.fromUserId = this.toChatUserId;
              messageData.fromUserName = this.toChatUserName;
              let interGroupMessage = localStorage.getItem('userName') + ": " + messageData.mediaThumb;
              messageData.mediaThumb = interGroupMessage;
            }
          }
        }
      }

      this.chatService.sendMessage(messageData);
      this.chatList.push(messageData);

      this.message = '';
      this.resetTextareaSize();
      this.timeoutIds.push(setTimeout(() => {
        this.scrollToBottom();
      }, 25));
    }
  }

  autoResizeTextarea(event: Event) {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    const lineHeight = parseFloat(getComputedStyle(textarea).lineHeight);
    const maxHeight = lineHeight * this.maxTextareaRows;
    if (textarea.scrollHeight > maxHeight) {
      textarea.style.height = maxHeight + 'px';
      textarea.classList.add('scrollable');
    } else {
      textarea.style.height = textarea.scrollHeight + 'px';
      textarea.classList.remove('scrollable');
    }
  }

  resetTextareaSize() {
    const textarea = document.querySelector('.chatContainer textarea') as HTMLTextAreaElement;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.classList.remove('scrollable');
    }
  }

  getURL(url: string) {
    if (this.isValidHttpUrl(url)) {
      return url;
    }
    return environment.AUTH_API_URL + 'chats/media/' + url;
  }

  isValidHttpUrl(urlString: string) {
    let url;

    try {
      url = new URL(urlString);
    } catch (_) {
      return false;
    }

    return url.protocol === 'http:' || url.protocol === 'https:';
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub: any) => sub.unsubscribe());
    this.timeoutIds.forEach(id => clearTimeout(id));
  }

  fileDownload(filename: string) {
    this.isDownloadingMedia = true;
    this.httpService
      .getUploadedFile(filename)
      .subscribe({
        next: (data: any) => {
          this.downloadFile(data, filename)
        },
        error: (error: any) => {
          this.isDownloadingMedia = false;
          if (error.status === 401) {
            this.appComponent.renewToken();
          }
        }
      });
  }

  downloadFile(event: any, filename: string) {
    this.isDownloadingMedia = false;
    let data = event as HttpResponse<Blob>;
    const downloadedFile = new Blob([data.body as BlobPart], {
      type: data.body?.type,
    });
    if (downloadedFile.type != '') {
      const a = document.createElement('a');
      a.setAttribute('style', 'display:none;');
      document.body.appendChild(a);
      a.download = filename;
      a.href = URL.createObjectURL(downloadedFile);
      a.target = '_blank';
      a.click();
      document.body.removeChild(a);
    }
  }

  fillInMsg(chat: any) {
    return `You have been approved to work the fill-in shift for ${chat.fillInRequest.ClientFirstName} ${chat.fillInRequest.ClientLastName} on ${chat.fillInRequest.DayDate}.  The shifts duration is ${chat.fillInRequest.Duration} and starts at ${chat.fillInRequest.StartTime}. The clients address is ${chat.fillInRequest.ClientAddress}.`;
    // return `Your request to fill-in shift for ${chat.fillInRequest.ClientFirstName} ${chat.fillInRequest.ClientLastName} at ${chat.fillInRequest.ClientAddress} has been approved.`;
  }

  fillInMsgRejected(chat: any) {
    return `Thank you for responding to the request.  Another caregiver has filled this shift already.  Thank you for being a team player and keep your eye out for future fill-in opportunities.`;
  }

  gotoForwardMessage() {
    const today: number = Date.now();
    const datePipe = new DatePipe('en-US');
    const date = datePipe.transform(today, 'dd/MM/yyyy');
    const time = datePipe.transform(today, 'shortTime');

    const agencycode = localStorage.getItem('agencycode');
    let forwardMsg = "";
    if (this.selection.selected.length > 1)
      forwardMsg = `FWD: ` + this.selection.selected.length + ` Messages from a conversation between ${this.getToUserName()} from ${agencycode} and ${localStorage.getItem('userName')}:`
    else
      forwardMsg = `FWD: From a conversation between ${this.getToUserName()} from ${agencycode} and ${localStorage.getItem('userName')}:`

    for (let index = 0; index < this.selection.selected.length; index++) {
      const element = this.selection.selected[index];
      let messageDate = new Date(element.createTime)
      forwardMsg = forwardMsg + " [Message " + (index + 1) + " from " + element.fromUserName + " at " + messageDate.toLocaleString('en-US') + "]: " + element.message;
    }
    // forwardMsg += ` forwarded ${date} @ ${time}`

    this.forwardMessage.emit(forwardMsg);
  }

  gotoCreateTicket() {
    const datePipe = new DatePipe('en-US');
    const selectedMessages = this.selection.selected.map((message: any) => {
      const forwardMsg = message.message ? `Create Ticket: From ${message.fromUserId} to ${message.toUserId} at ${datePipe.transform(message.createTime, 'dd/MM/yyyy')} @ ${datePipe.transform(message.createTime, 'shortTime')} : ${message.message}`
        : `Create Ticket: From ${message.fromUserId} to ${message.toUserId} at ${datePipe.transform(message.createTime, 'dd/MM/yyyy')} @ ${datePipe.transform(message.createTime, 'shortTime')} : ${message.media}`
      return {
        _id: message._id,
        createTime: message.createTime,
        message: message.message,
        fromUserId: message.fromUserId,
        toUserId: message.toUserId,
        messageType: message.messageType,
        messageId: message.messageId,
        forwardMsg: forwardMsg, // Adding the forwardMsg field
        media: message.media
      };
    });

    localStorage.setItem('selected_message', JSON.stringify(selectedMessages));

    this.router.navigate(['/threads/create', { from: 'chat' }]);
  }

  // Deprecated: URL navigation on message click removed for security & UX; link handling now done via anchor tags in pipe.

  getGroupName() {
    if (this.groupName === this.toChatUserId)
      return ""
    if (this.groupName) {
      // console.log()
      if(this.chatList[0]) {
        if(this.chatList[0].fromUserId !== this.toChatUserId)
          return this.chatList[0].fromUserName + " + "
        else 
          return this.chatList[0].toUserName + " + "
      }
      return this.groupName + " + "
    }
    else
      return ""
  }

  handleOnIt() {
    this.alertGroup = false;
    this.message = "I am working on this now";
    this.sendMessage();
    this.updateAlertGroup("On It");
  }

  handleRemoveAlert() {
    if (window.confirm('Are you sure you want to remove this alert?')) {
      this.alertGroup = false;
      this.updateAlertGroup("Removed Alert");
    }
  }

  updateAlertGroup(message) {
    this.httpService.updateAlertGroup(this.connectionId, this.groupName).subscribe({
      next: (res: any) => {
        if (res)
          this.openSnackBar('Successfully ' + message, '');
        else
          this.openSnackBar('Error Trying To ' + message, '');
      },
      error: (error) => {
        if (error.status === 401) {
          this.appComponent.renewToken()
          // localStorage.clear();
          // this.router.navigate(['/login']);
        }
      },
      complete: () => { },
    });
  }
}



